import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { LeftFooterContainer } from './LoginLayout.styled'
import { gridBreakPoints } from 'common/theme'
import { assetFolders, currentAssetFolder } from 'common/constants'

export const StyledMainNavItem = styled.div`
  width: ${() => (currentAssetFolder.isIndependent ? '25%' : '20%')};
  @media (max-width: ${gridBreakPoints.xl}) {
    width: 25%;
  }
  @media (max-width: ${gridBreakPoints.lg}) {
    width: 30%;
    margin-top: 1rem;
  }
`
export const StyledFooter = styled.div<{ assetFolder?: string }>`
  background: ${({ theme }) => {
    if (currentAssetFolder.isInfiniti) return theme.colors.InfinitiFooterBackgroundColor
    if (currentAssetFolder.isIndependent || currentAssetFolder.isUndefined)
      return theme.colors.IndependentFooterBackgroundColor
    return theme.colors.footer
  }};
  font-size: 1.4rem;
  padding: 2.4rem 0 1.6rem;
  width: 100%;

  > .row {
    width: 100%;
    @media (min-width: ${gridBreakPoints.md}) {
      min-height: 21rem;
    }
  }

  nav {
    justify-content: flex-end;
    padding-left: 4rem;
  }

  .nav-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ul {
    list-style: none;
    padding-inline-start: 0;
  }

  a {
    color: ${({ theme }) => {
      if (currentAssetFolder.isInfiniti) return theme.colors.InfinitiFooterFontColor
      if (currentAssetFolder.isIndependent || currentAssetFolder.isUndefined)
        return theme.colors.IndependentFooterFontColor
      return '#fff'
    }};
    text-decoration: none;
  }

  .subnav li {
    padding-top: 0.475rem;
  }

  .nav-link {
    padding: 0;
  }

  .more-section {
    text-align: end;
    width: 80%;
    position: absolute;
    right: 3rem;
  }
`

export const StyledFooterRow = styled(Row)`
  margin: 0;
`
export const StyledNavItem = styled.a`
  text-transform: uppercase;
  font-weight: 800;
  display: inline-block;
  margin-bottom: 1.5rem;
`
export const StyledFooterNav = styled.li`
  margin-top: 0.4rem;
`

export const StyledFooterLogout = styled.li`
  margin-top: 2.75rem;
  font-weight: 600;
`

export const StyledLogoContainer = styled(Col)`
  align-self: flex-end;
  padding-right: 2.75rem;
`

export const StyledSubNavSmallScreen = styled.div`
  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    li {
      padding: 0 1rem;

      &:last-child {
        border-left: 0.1rem solid ${({ theme }) => theme.colors.fontColor};
      }
    }
  }
`
export const LayoutLeftFooterContainer = styled(LeftFooterContainer)`
  color: #fff;
  display: flex;
  align-items: flex-end;
  padding-left: 2.75rem;
  font-size: 1.1rem;
`

export const StyledFooterLogo = styled.div<{ assetFolder?: string }>`
  display: flex;
  justify-content: flex-end;
  text-align: end;
  transform: ${() => currentAssetFolder.isNissan && 'brightness(0) invert(1)'};
  padding-top: 2rem;
  > img {
    max-height: 5rem;
    filter: ${() => currentAssetFolder.isNissan && 'brightness(0) invert(1)'};
  }
`

export const SeperatorFAQMenu = styled.hr`
  width: 80%;
  border-bottom: 0.01px solid rgb(153 149 149 / 50%);
  margin-bottom: 0;
  margin-right: 0;
  margin-left: auto;
`

export const LogoutFooterListItem = styled.li`
  text-transform: uppercase;
`
